import { BaseResponse } from './internal/baseresponse';
export class TransactionReadytoPayResult extends BaseResponse {
  data: null;
}



// WEBPACK FOOTER //
// ./src/app/response/transactionreadytopayresult.ts